import { Box, ColorPicker, Select, Stack } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { LinkThemeState } from './types'
import events from '@dtx-company/inter-app/src/event-tracking/events/flowpage'

export const TEXT_SIZE_OPTIONS = [
  { label: '8', value: '8' },
  { label: '10', value: '10' },
  { label: '12', value: '12' },
  { label: '16', value: '16' },
  { label: '20', value: '20' },
  { label: '24', value: '24' }
]

export const LinkStyleForm: FC<LinkThemeState> = ({
  linkTheme,
  setLinkTheme,
  hiddenFields,
  disabled
}) => {
  return (
    <Stack direction="column" data-testid="link-style-form" gap={'8px'}>
      {!hiddenFields?.textSize && (
        <Box>
          <Select
            label="Text Size"
            options={TEXT_SIZE_OPTIONS}
            value={(!disabled && linkTheme?.textSize?.toString()) || ''}
            name="textSize"
            onChange={event => {
              const size = parseInt(event.target.value)
              setLinkTheme({ textSize: size })
              events.Flowpage_PageProfile_Selected_Link_Level_Text_Size(size)
            }}
            inputProps={{ bg: 'primary.white' }}
            disabled={disabled}
          />
        </Box>
      )}

      {!hiddenFields?.fontColor && (
        <Box>
          <ColorPicker
            label="Font Color"
            value={(!disabled && linkTheme?.fontColor) || ''}
            onChange={color => {
              events.Flowpage_PageProfile_Selected_Link_Level_Font_Color(color)
              setLinkTheme({ fontColor: color })
            }}
            disabled={disabled}
          />
        </Box>
      )}

      {!hiddenFields?.linkColor && (
        <Box>
          <ColorPicker
            label="Link Color"
            value={(!disabled && linkTheme?.linkColor) || ''}
            onChange={color => {
              events.Flowpage_PageProfile_Selected_Link_Level_Link_Color(color)
              setLinkTheme({ linkColor: color })
            }}
            disabled={disabled}
          />
        </Box>
      )}

      {!hiddenFields?.borderColor && (
        <Box>
          <ColorPicker
            label="Border Color"
            value={(!disabled && linkTheme?.borderColor) || ''}
            onChange={color => {
              events.Flowpage_PageProfile_Selected_Link_Level_Border_Color(color)
              setLinkTheme({ borderColor: color })
            }}
            disabled={disabled}
          />
        </Box>
      )}

      {!hiddenFields?.shadowColor && (
        <Box>
          <ColorPicker
            label="Shadow Color"
            value={(!disabled && linkTheme?.shadowColor) || ''}
            onChange={color => {
              events.Flowpage_PageProfile_Selected_Link_Level_Shadow_Color(color)
              setLinkTheme({ shadowColor: color })
            }}
            disabled={disabled}
          />
        </Box>
      )}
    </Stack>
  )
}
